module.exports = __webpack_public_path__ + "assets/images/Order_Type_T_Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Order_Type_T_Icon.png
// module id = 1428
// module chunks = 1